import RuleSetLibrary from "../../sports/football/rules/ruleset-library";
import BaseRuleSetProcessor from "./base-ruleset-processor";
import FootballRulesetContext from "../../sports/football/football-ruleset-context";

class FootballRuleSetProcessor extends BaseRuleSetProcessor {
    async _process(gameContext, eventConfiguration, { play }, event) {
        const ruleSetContext = new FootballRulesetContext();
        const ruleSet = RuleSetLibrary.getRuleSetById(
            gameContext.ruleSetId
        ).rules;

        let changes = [];
        for (const fragment of play.fragments) {
            const fragmentChanges = await this._processTree(
                ruleSet,
                gameContext,
                ruleSetContext,
                eventConfiguration,
                { play, fragment },
                event
            );
            changes = changes.concat(fragmentChanges);
        }

        return { ruleSetContext, changes };
    }
}

export default new FootballRuleSetProcessor();
